import './boot.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App.js';
import ErrorBoundary from './App/ErrorBoundary.js'; // Import the ErrorBoundary component
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './App/ThemeContext';
import { Buffer } from 'buffer'
import ConsentBanner from './Components/ConsentBanner'; // New consent banner with Google Consent Mode v2
import {parseKBSubdomain} from "./App/utils";
import {PromptProvider} from "./Components/PromptContext";
import {ConfirmProvider} from "./Components/ConfirmContext";

window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
const parsedSubdomain = parseKBSubdomain();
const isInIframe = window.self !== window.top;

root.render(
    <ErrorBoundary> {/* Wrap your components with ErrorBoundary */}
        <ThemeProvider>
            <BrowserRouter>
                {/* Show consent banner on all domains but NOT in iframe (client sites) */}
                {!isInIframe && (
                    <ConsentBanner />
                )}
                <PromptProvider>
                    <ConfirmProvider>
                        <App />
                    </ConfirmProvider>
                </PromptProvider>
            </BrowserRouter>
        </ThemeProvider>
    </ErrorBoundary>
);

reportWebVitals();

// Check if service workers are supported
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
            .then((registration) => {
                // Registration was successful
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
            })
            .catch((err) => {
                // Registration failed
                console.log('ServiceWorker registration failed: ', err);
            });
    });
}